import type { ProductPageViewModel } from 'autogen/swagger/all';
import Layout from 'components/Layout';
import { useTranslation } from 'react-i18next';
import WhenSplitTestVariant from 'helpers/WhenSplitTestVariant';
import Reviews from 'components/reviews/reviews';
import { ColorNordicGrey4 } from 'autogen/design-tokens/tokens';
import { CustomerReviews } from 'autogen/translation-keys/trans-website-productreview-list';
import ProductInformation from './components/ProductInformation';
import StyledProductRecommendationLoader from './shared/styles';
import CustomMediaContent from './components/CustomMediaContent';
import Flowbox from './components/Flowbox';

export type DysonProductPageProps = {
    model: ProductPageViewModel;
};

export default function DysonProductPage(props: DysonProductPageProps) {
    const { model } = props;
    const { productInformation, recommendationRequest, reviews, emaLogo, flowBoxModel } = model;
    const { t } = useTranslation();

    return (
        <Layout.Page>
            {/* Product Information */}
            <Layout.Section>
                <ProductInformation productInformation={productInformation} emaLogo={emaLogo} />
            </Layout.Section>

            {/* Dyson specifications */}
            {productInformation.customMediaContent.length > 0 && (
                <Layout.Section>
                    <CustomMediaContent customMediaContent={productInformation.customMediaContent} />
                </Layout.Section>
            )}

            {/* Flowbox - User Generated Content */}
            {flowBoxModel && (
                <Layout.Section>
                    <Flowbox model={flowBoxModel} productId={productInformation.productId} />
                </Layout.Section>
            )}

            {/* Product Recommendation */}
            {recommendationRequest && (
                <Layout.Section>
                    <StyledProductRecommendationLoader model={recommendationRequest?.recommendationRequest} />
                </Layout.Section>
            )}

            {/* Product Reviews */}
            {reviews.reviews && (
                <Layout.Section.WithFullWidthBackground backgroundColor={ColorNordicGrey4} heading={t(CustomerReviews)}>
                    <Reviews model={reviews.reviews} />
                </Layout.Section.WithFullWidthBackground>
            )}
        </Layout.Page>
    );
}
